import * as React from 'react'
import colors, { Color } from '../../../theme/colors'

type Props = {
  width?: number,
  height?: number,
  color?: Color
}

const ArrowRightSvg = ({ width, height, color, ...rest }: Props) => (
  <svg width={width} height={height} viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M1.29032 12C0.516129 12 0 11.5385 0 10.8462C0 10.5 0.129032 10.2692 0.387097 10.0385L4.90323 6L0.387097 1.96154C-0.129032 1.5 -0.129032 0.807692 0.387097 0.346154C0.903226 -0.115385 1.67742 -0.115385 2.19355 0.346154L7.6129 5.19231C8.12903 5.65385 8.12903 6.34615 7.6129 6.80769L2.19355 11.6538C1.93548 11.8846 1.54839 12 1.29032 12Z"
      fill={color}
    />
  </svg>
)

ArrowRightSvg.defaultProps = {
  width: 12,
  height: 8,
  color: colors.Primary.GreyText
}

export default ArrowRightSvg
